import { colors, radius, spacing, Typography } from '@lamimed/pantheon';
import styled from 'styled-components';

export const ProductCard = styled.div`
  display: flex;
  background-color: ${colors.neutral_extra_light};
  border-radius: ${radius.small};
  padding: ${spacing.medium};
  justify-content: space-between;
`;

export const Wrapper = styled.div`
  display: flex;
`;

export const ThumbBox = styled.div`
  width: 5rem;
  height: 5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${colors.gradient__primary};
  border-radius: ${radius.small};
  margin-right: ${spacing.small};
`;

export const ProductInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SmallText = styled(Typography)`
  font-size: 1rem;
`;

export const QuantityWrapper = styled.div`
  display: flex;
  align-items: flex-start;

  > button {
    align-items: flex-start;
  }
`;

export const QuantityDisplay = styled(Typography)`
  background-color: ${colors.light};
  border-radius: ${radius.small};
  width: 4rem;
  height: 2rem;
  text-align: center;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
`;
